var ready = require('./ready.js');

ready(function() {
    var recalculate = function(event) {
        event.target.classList.toggle('placeholder-shown', !event.target.value);
    }

    var inputSelector = 'input[type=text],input[type=url],input[type=tel],input[type=number],input[type=file],input[type=email],textarea,select';
    var elements = document.querySelectorAll(inputSelector);

    Array.prototype.forEach.call(elements, function(el) {
        recalculate({ target: el });
        el.addEventListener('keyup', recalculate);
        el.addEventListener('change', recalculate);
    });
});
